module.exports = __webpack_public_path__ + "img/benefits01-03.1e46380.png";